import React from "react"
import styled from "styled-components"
import { DropdownItem } from "reactstrap"
import PropTypes from "prop-types"

const CSelectContent = ({ options, isMulti, onChange, value }) => {

  const onClick = (item, isChecked) => {
    if (!isMulti) return onChange(item)

    if (isChecked) {
      return onChange([...value, item])
    } else {
      return onChange(value.filter(i => i.value !== item.value))
    }
  }

  return (
    <CSelectContentStyled>
      {options?.length > 0 ? options.map(i => {
        const isChecked = value.some(v => v.value === i.value)
        return (
          <DropdownItem key={i.value} toggle={!isMulti} onClick={() => onClick(i, !isChecked)}
                        className={(!isMulti && isChecked && "dropdown-item__active") || ''}>
            {isMulti ? <React.Fragment>
              <span className="dropdown-item__label">
                <input
                  className="form-check-input me-2"
                  type="checkbox"
                  checked={isChecked}
                  onChange={() => {
                  }}
                  tabIndex={-1}
                />
                {i.label}
              </span>
              </React.Fragment>
              : <span className={`dropdown-item__label`}>{i.label}</span>
            }
          </DropdownItem>
        )
      })
        : <React.Fragment>
          <DropdownItem toggle={false} className="no-options" disabled>
            No data...
          </DropdownItem>
        </React.Fragment>
      }

    </CSelectContentStyled>
  )
}

CSelectContent.propTypes = {
  options: PropTypes.array,
  isMulti: PropTypes.bool,
  onChange: PropTypes.func,
  value: PropTypes.array
}

const CSelectContentStyled = styled.div`
  max-height: 260px;
  overflow-y: auto;

  .dropdown-item__active {
    background-color: #2684FF;
    color: hsl(0, 0%, 100%);
    cursor: default;
  }

  .dropdown-item__label {
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
    display: list-item;
  }
  
  .no-options {
    text-align: center;
    color: #aaa;
  }
`

export default (CSelectContent)
